import type { ReactNode } from 'react';

export interface WizardStepProps {
  label: string;
  hideStep?: boolean;
  children: ReactNode | Array<ReactNode>;
  /**
   * The action to execute when navigating to the previos step.
   *
   * Only applies from the second step onwards.
   *
   * @returns true if it should proceed to the previous step, false otherwise
   */
  onBack?: () => boolean;
  /**
   * The action to execute when navigating to the next step.
   *
   * Only applies up until the last step
   *
   * @returns true if it should proceed to the next step, false otherwise
   */
  onNext?: () => boolean;
}

const WizardStep = ({ children }: WizardStepProps) => {
  return children;
};

export default WizardStep;
